__turbopack_context__.v({
  "hero_background": "WallofShowPostersBackgroundImage-module-scss-module__dB8jrG__hero_background",
  "hero_square_background": "WallofShowPostersBackgroundImage-module-scss-module__dB8jrG__hero_square_background",
  "page_background": "WallofShowPostersBackgroundImage-module-scss-module__dB8jrG__page_background",
  "row_background": "WallofShowPostersBackgroundImage-module-scss-module__dB8jrG__row_background",
});
